import { LocalStorage } from '@service/LocalStorage';

import { localStorageKeys } from '..';

type keys = keyof typeof localStorageKeys;

export const getLocalStorage = (key: keys) => LocalStorage.get(localStorageKeys[key]);
